// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__uIEoR","menu__lista":"Menu_menu__lista__8XDR9","menu__item":"Menu_menu__item__+bZF5"};